import { TWindow } from '../basis/types/twindow';
import { getQueryString } from './uri';

const NODE_ENV = process.env.NODE_ENV;

// 是否为本地开发环境
export const isDevelopment = NODE_ENV === 'development';

// 是否为调试模式
export const isDebug = getQueryString('vconsole') === 'debug';

export const globalMeeting = (window as any).__meeting__ as TWindow.WindowMeeting;
